<template>
<div
  id="full-overlay"
  :class="{
    'd-none': !show,
  }"
>
  <div
    class="spinner-border text-warning"
    style="width: 3.5rem; height: 3.5rem;"
    role="status">
    <span class="visually-hidden">Loading...</span>
  </div>
</div>
</template>

<style scoped lang="css">
#full-overlay {
  display: flex;
  justify-content: space-around;
  align-items: center;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow: auto;
  overflow-y: hidden;
  z-index: 9999;
  background-color: rgba(0,0,0, 0.5);
}

.spinner {
  margin: auto;
  z-index: 99999;
  background-color: rgba(255,255,255, 0.1);
  color: rgba(0, 0, 0, 0.1);
}
</style>

<script>
export default {
  name: "Loading",
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
    };
  },
  created() {
  },
  methods: {
  },
};
</script>
